<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <router-link :to="{ name: 'demo-signup', params: {} }">
            <i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>
          </router-link>
          <b><trans-text i18nKey="ui[3][1]"/></b>
        </h3>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">
          <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
            <b><trans-text :i18nKey="apiErrorI18nKey"/></b>
          </div>

          <!-- 入力フォーム -->
          <page-form @tryForm="tryForm" :user="user"></page-form>

          <!-- 画面遷移UI -->
          <div class="row text-center">
            <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
              <div class="">
                <router-link tag="button" class="btn w-100 btn-lg btn-default" :to="{ name: 'demo-signup', params:{} }">
                  <trans-text i18nKey="ui[3][7]"/>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from 'page/partials/Verify/PageForm.vue'

  import DemoRegister from 'processor/DemoRegister'

  export default {
    name:"Verify",
    components: {
      PageForm,
    },
    data () {
      return {
        user: store.get("provisionalUser") || {},
        apiErrorI18nKey:null
      }
    },
    created(){
    },
    methods:{
      tryForm(input){
        DemoRegister.committalRegister(input)
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKey = res.apiErrorI18nKey
              return
            }
            this.$router.push({ name: 'mypage', params: {}})
          })
      }
    }

  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Verify.vue?724e1592